import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class AllianceService {

    private url: string;

    constructor(private http: HttpClient, public router: Router) {
        this.url = environment.apiUrl;
    }

    /**
     *
     */
    public searchTitle(isbn: string): Observable<object> {
        const params = new HttpParams()
            .append('isbn', isbn.toString());

        return this.http
            .get(`${this.url}/stocks/searchtitle`, { responseType: 'json', params })
            .pipe(
                catchError(this.errorHandler)
            );
    }

    /**
     *
     * @param error
     */
    private errorHandler(error: HttpErrorResponse) {
        return throwError(error);
    }
}
